const CJK_RANGE = /[㐀-鿿]/;

export function initials(name: string): string {
  const cjkMatch = name.match(new RegExp(`${CJK_RANGE.source}+`, 'u'));
  if (cjkMatch) {
    return cjkMatch[0].slice(0, 2);
  }
  return name
    .replace(/[^\p{L}\p{N} ]/gu, '')
    .split(' ')
    .filter(Boolean)
    .slice(0, 2)
    .map((w) => w[0])
    .join('')
    .toUpperCase();
}
